import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const TakeActionPlantersPage = () => {
  return <SanityContentPage slug='planters' />
}

export default TakeActionPlantersPage
